import React, { useContext } from "react";
import "./style4.css";
import MyContext from "../../InvoiceForm/Context";

// function Invoice() {
const Invoice4 = () => {
  const invoiceData = useContext(MyContext);

  const printDiv = (divID) => {
    const divElements = document.getElementById(divID).innerHTML;
    const oldPage = document.body.innerHTML;

    // Insert the content into the print window
    document.body.innerHTML = `<html>
        <head>
          <title>Print</title>
        </head>
        <body>
          ${divElements}
        </body>
      </html>`;

    // Trigger the print dialog
    window.print();

    // Restore the original page content
    document.body.innerHTML = oldPage;
  };

  const onClose = () => {
    invoiceData.setSelectedContainer(null);
    invoiceData.setForceRerender((prev) => prev + 1); // Trigger re-render
  };
  return (
    <div>
      <div id="Invoice4print" className="invoice-container">
        <header className="invoiceheader">
          <div className="logo">
            <img src={invoiceData.imageUrl} alt="Company Logo" />
          </div>
          <div className="companydetails">
            <strong> {invoiceData.companyName}</strong>
            <br />
            {/* <strong> {invoiceData.name}</strong>
            <br /> */}
            <strong> {invoiceData.gstin}</strong>
            <br />
            <strong>{invoiceData.address}</strong>
            <br />
            <strong>{invoiceData.address2}</strong>
            <br />
            <strong>{invoiceData.city}</strong>
            <br />
            <strong>{invoiceData.state}</strong>
            <br />
            <strong>{invoiceData.country}</strong>
          </div>
        </header>
        {/* <div className="invoicetitle">
          <h1>INVOICE</h1>
        </div> */}
        <section className="client-details">
          <div className="bill--to">
            <h3>Bill To</h3>
            <strong>{invoiceData.clientCompany}</strong>
            <br />
            <strong>{invoiceData.clientGstin}</strong>
            <br />
            <strong>{invoiceData.clientAddress}</strong>
            <br />
            <strong>{invoiceData.clientAddress2}</strong>
            <br />
            <strong>{invoiceData.clientCity}</strong>
            <br />
            <strong>{invoiceData.clientState}</strong>
            <br />
            <strong>{invoiceData.clientCountry}</strong>
          </div>
          {invoiceData.toggleSwitch &&<div className="ship-info"> 
        <strong style={{ color: "black" }}>Ship To:</strong>
        <br />
        <br />
        <strong>{invoiceData.shipToCompany}</strong>
        <br />
        <strong>{invoiceData.shipToGstin}</strong>
        <br />
        <strong>{invoiceData.shipToAddress}</strong>
        <br />
        <strong>{invoiceData.shipToAddress2}</strong>
        <br />
        <strong>{invoiceData.shipToCity}</strong>
        <br />
        <strong>{invoiceData.shipToState}</strong>
        <br />
        <strong>{invoiceData.shipToCountry}</strong>
        <br />
      </div>}
          <div className="invoice-info">
            <table>
              <tbody>
                <tr>
                  <td>Invoice#</td>
                  <td>{invoiceData.invoiceNumber}</td>
                </tr>
                <tr>
                  <td>Invoice Date</td>
                  <td>{invoiceData.invoiceDate}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
        <table className="invoice-items">
          <thead>
            <tr>
              <th>Description</th>
              <th>Quantity</th>
              <th>Rate</th>
              <th>HSN Code</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {invoiceData?.tableData?.map((data, index) => (
              <tr key={index}>
                <td>{data.description}</td>
                <td>{data.qty}</td>
                <td>{data.rate}</td>
                <td>{data.hsn}</td>
                <td>{data.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="total-section">
          <table className="total-amount">
            <tbody>
              <tr>
                <td colSpan="3"></td>
                <td>SubTotal</td>
                <td>{invoiceData.subTotal.toFixed(2)}</td>
              </tr>
              <tr>
                <td colSpan="3"></td>
                <td>SGST {invoiceData.sgst}%</td>
                <td>
                  {((invoiceData.subTotal / 100) * invoiceData.sgst).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td colSpan="3"></td>
                <td>CGST {invoiceData.cgst}%</td>
                <td>
                  {((invoiceData.subTotal / 100) * invoiceData.cgst).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td colSpan="3"></td>
                <td>GST {invoiceData.gst} %</td>
                <td>
                  {(invoiceData.subTotal * (invoiceData.gst / 100)).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td colSpan="4">Total Amount</td>
                <td>{invoiceData.total.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer className="invoice-footer">
        <h4>Terms</h4>
            <div
              style={{
                minWidth: "50%",
                minHeight: "80%",
                maxWidth: "auto",
                minHeight: "auto",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              {invoiceData.terms}
            </div>
            <hr />
            <h4>Notes</h4>
            <div
              style={{
                minWidth: "100%",
                minHeight: "80%",
                maxWidth: "auto",
                minHeight: "auto",
              }}
            >
              {invoiceData.notes}
            </div>
        </footer>
        <div className="thanks">
                <td colSpan="2">
                  <strong>Thank you for the Business</strong>
                </td>
              </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <section style={{ marginTop: "20px" }}>
          <button
            onClick={() => printDiv("Invoice4print")}
            style={{
              marginRight: "10px",
              background: "green",
              borderRadius: "5px",
              color: "white",
              border: "none",
              padding: "5px 10px",
            }}
          >
            Print
          </button>
          <button
            onClick={onClose}
            style={{
              marginRight: "10px",
              background: "red",
              borderRadius: "5px",
              color: "white",
              border: "none",
              padding: "5px 10px",
            }}
          >
            Close
          </button>
        </section>
      </div>
    </div>
  );
};

export default Invoice4;
